module.exports = __webpack_public_path__ + "static/media/thumbnail_play_blue.31468ec8.svg";